import svcLogo from "@/assets/svc-logo.jpg";
import svcWebsite from "@/assets/svc-website.jpg";
import svcWhatsapp from "@/assets/svc-whatsapp.jpg";
import svcPosters from "@/assets/svc-posters.jpg";
import svcProfile from "@/assets/svc-profile.jpg";
import svcSeo from "@/assets/svc-seo.jpg";
import svcMarketing from "@/assets/svc-marketing.jpg";
import svcApparel from "@/assets/svc-apparel.jpg";
import svcGazebos from "@/assets/svc-gazebos.png.asset.json";
import svcBanners from "@/assets/svc-banners.png.asset.json";


// Swap any `image` below with your own photo to use real client work.
export const services = [
  { image: svcLogo, title: "Logo Design & Brand Identity", desc: "A distinctive, professional identity your customers remember and trust." },
  { image: svcWebsite, title: "Landing Pages & Websites", desc: "Fast, mobile-friendly websites built to convert visitors into enquiries." },
  { image: svcWhatsapp, title: "WhatsApp Business Setup", desc: "Professional profile, catalogue, auto-replies and quick-reply systems." },
  { image: svcPosters, title: "Social Media Posters", desc: "On-brand posters that promote your services and stop the scroll." },
  { image: svcProfile, title: "Business Profiles & Documents", desc: "Polished company profiles and stationery you can confidently send out." },
  { image: svcSeo, title: "SEO & Keyword Strategy", desc: "Get found on Google by the customers actively searching for you." },
  { image: svcMarketing, title: "Digital Marketing Campaigns", desc: "Targeted ads and content systems that drive real leads, not vanity metrics." },
  { image: svcApparel, title: "Branded Apparel & Gifts", desc: "Uniforms, t-shirts and corporate gifts that extend your brand everywhere." },
  { image: svcGazebos.url, title: "Branded Gazebos & Event Setups", desc: "Full-print gazebos, table cloths and event stands that turn any pop-up into a branded experience." },
  { image: svcBanners.url, title: "Pull-up Banners & Feather Flags", desc: "Eye-catching roll-up banners, feather flags and signage for showrooms, expos and activations." },
];
